<template>
  <Card v-if="offersVisible" :title="$t('Offers')">
    <CardSection>
      <FormLayout>
        <FormLayoutGroup>
          <Select v-if="inactiveOffers.length"
            v-model="quickSelectedId"
            :placeholder="$t('Choose an offer')"
            :options="inactiveOffers"
          />
          <Button :disabled="!quickSelectedId || !offersVisible" @click="addSelectedId">{{$t('Add to Segment')}}</Button>
        </FormLayoutGroup>
      </FormLayout>
    </CardSection>
    <CardSection v-if="activeOffers.length" :title="$t('Active in Segment')">
      <DataTable
        :columns="[
          {
            key: 'displayText',
            label: $t('Offer'),
            sortable: true
          },
          { 
            key: 'code',
            label: $t('Code')
          },
          { 
            key: 'status',
            label: $t('Status')
          },
          {
            key: 'variant',
            label: $t('Variant')
          }
        ]"
        :row-actions="[
          {
            label: $t('Go to offer'),
            onAction: (row) => goToOffer(row.id)
          },
          {
            label: $t('Remove'),
            onAction: (row) => removeById(row.id)
          }
        ]"
        :rows="activeOffers"
        :sort.sync="sortBy"
      >
        <template v-slot:col:displayText="{row}">
          {{row.displayText}}
          <Caption v-if="row.listSummary">{{row.listSummary}}</Caption>
        </template>
        <template v-slot:col:status="{row}">
          <Badge v-if="!row.isDisabled" status="success">{{$t('Active')}}</Badge>
          <Badge v-else-if="row.isDisabled" status="warning">{{$t('Inactive')}}</Badge>
          <div><Badge v-if="row.status === 'runOut'" status="attention">{{$t('campaignEdit.offer.Low Codes')}}</Badge></div>
          <div><Badge v-if="outsideValidityPeriod(row)" status="info">{{$t('campaignEdit.segment.Outside validity period')}}</Badge></div>
        </template>
        <template v-slot:col:code="{row}">
          <Badge v-if="row.promoType === 'file'" status="info">{{$t('Multiple')}}</Badge>
          <template v-else-if="row.promoType === 'code'">{{row.code}}</template>
        </template>
      </DataTable>
    </CardSection>
  </Card>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'SegmentOfferManager',
  props: {
    campaign: {
      type: Object,
      required: true
    },
    offersVisible: {
      type: Boolean,
      required: true
    },
    offers: {
      type: Array,
      required: true
    },
    segment: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      quickSelectedId: null,
      sortBy: {
        column: 'displayText',
        direction: 'asc'
      }
    } 
  },
  mounted() {
  },
  computed: {
    inactiveOffers() {
      let offers = this.offers.filter((offer) => {
        return !offer.isActive && !offer.isDisabled
      })
      offers = _.orderBy(offers, [offer => offer.displayText && offer.displayText.trim().toLowerCase()], ['asc'])
      return offers
    },
    activeOffers() {
      let offers = this.offers.filter((offer) => {
        return offer.isActive
      }).map(o => {
        return {
          ...o,
          variant: this.getVariant(o) || 'N/A'
        }
      })
      if (this.sortBy) {
        let iteree = this.sortBy.column
        if (this.sortBy.column === 'displayText') {
          iteree = offer => offer.displayText && offer.displayText.trim().toLowerCase()
        }
        offers = _.orderBy(offers, [iteree], [this.sortBy.direction])
      }
      return offers
    } 
  },
  methods: {
    getVariant(offer) {
      return offer.settings && offer.settings.classes
    },
    goToOffer(id) {
      let routeData = this.$router.resolve(`/campaigns/${this.campaign.id}/offers/edit/${id}`)
      window.open(routeData.href, '_blank'); 
    },
    addSelectedId() {
      if (this.quickSelectedId) {
        this.addById(this.quickSelectedId)
        this.quickSelectedId = null
      }
    },
    addById(id) {
      let offerIndex = this.offers.findIndex(o => o.id === id)
      
      if (this.offers[offerIndex]) {
        this.offers[offerIndex].isActive = true
      }

      let index = this.segment.offerIds.indexOf(id)
      if (index === -1) {
        if (this.offers[offerIndex]) {
          this.segment.offerIds.push(id)
          this.offers[offerIndex].used = true
        }
      }
    },
    removeById(id) {
      let offerIndex = this.offers.findIndex(o => o.id === id)
      if (this.offers[offerIndex]) {
        // console.log('offerIndex', offerIndex, 'isActive', this.offers[offerIndex].isActive, this.offers[offerIndex])
        this.offers[offerIndex].isActive = false
      }
      
      let index = this.segment.offerIds.indexOf(id)
      if (index !== -1) {
        this.segment.offerIds.splice(index, 1)
      }
    },  
  }
}
</script>

<style>

</style>